import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getMyCars } from '../../../store/auctions/action';
import MyCarsList from './component';

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getMyCarsConnect: getMyCars
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyCarsList);